<template>
   <div class="container-mobile">
      <formulaire-ruche mode="edit"></formulaire-ruche>
   </div>
</template>

<script>
import FormulaireRuche from "./FormulaireRuche";
export default {
   components: {
      FormulaireRuche
   },
   mounted() {
      this.$store.commit("setTitre", "Modifier une ruche");
   }
};
</script>
